<template>
  <v-card>
    <v-toolbar dark color="light-blue lighten-1">
      <v-btn icon dark @click.native="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
        <v-toolbar-title>Edit Blog</v-toolbar-title>
    </v-toolbar>

    <v-divider></v-divider>

    <v-container>
        <v-form ref="form" v-model="isFormValid">
            <v-text-field
              v-model="title"
              label="Title"
              required
              :rules="titleRules"
              append-icon="mdi-pen"
            ></v-text-field>
            <v-textarea
              v-model="description"
              label="Description"
              filled
              required
              auto-grow
              :rules="descriptionRules"
              append-icon="mdi-book-open-variant"
            ></v-textarea>

            <div class="text-xs-center">
              <v-btn
                :disabled="!isFormValid"
                color="primary"
                class="mr-4"
                @click="submit"
              >
                Update
                <v-icon right dark> mdi-lock-open </v-icon>
              </v-btn>
              <v-btn
                color="error"
                class="mr-4"
                @click="reset"
              >
                Reset Form
                <v-icon right dark> mdi-refresh </v-icon>
              </v-btn>
              <v-btn
                color="warning"
                class="mr-4"
                @click="close"
              >
                Cancel
                <v-icon right dark> mdi-cancel </v-icon>
              </v-btn>
            </div>

        </v-form>
    </v-container>

  </v-card>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'

export default {
  data(){
    return{
      isFormValid: false,
      title: '',
      description: '',
      apiDomain: "https://demo-api-vue.sanbercloud.com",
      titleRules: [
          v => !!v || 'Judul tidak boleh kosong!',
          v => (v && v.length > 15) || 'Judul harus lebih dari 15 karakter!',
      ],
      descriptionRules: [
        v => !!v || 'deskripsi tidak boleh kosong!',
        v => (v && v.length > 50) || 'Deskripsi harus lebih dari 50 karakter!',
      ]
    }
  },

  computed: {
    ...mapGetters({
      token: 'auth/token',
      params: 'dialog/params'
    })

  },

  methods: {
    ...mapActions({
      setAlert : 'alert/set',
      //setToken : 'auth/setToken',
    }),

    go(){
      this.title = this.params[1]
      this.description = this.params[2]
    },

    reset(){
      this.title = '',
      this.description = ''
    },

    close(){
      this.$emit('closed', false)
      window.location.reload()
    },

    submit(){

      if((this.title == '') || (this.description == '')){
        this.setAlert({
            status: true,
            color: 'error',
            text: 'Data tidak valid! Silahkan coba lagi',
        })
      }
      else{

        let formData = new FormData()
        formData.append("title", this.title)
        formData.append("description", this.description)

        const config = {
          method: "post",
          url: this.apiDomain + "/api/v2/blog/" + this.params[0],
          params : { _method : 'PUT'},
          data: formData,
          headers: {
            'Authorization' : 'Bearer' + this.token,
          },
        }

        this.axios(config)
          .then( (response) => {
            console.log(response.data);
            this.setAlert({
                status: true,
                color: 'success',
                text: 'Blog Berhasil Diupdate!',
            })
            this.close()
            //this.$router.push("/")
            window.location.reload()
          })
          .catch( (response) => {
            console.log(response)
            this.setAlert({
                status: true,
                color: 'error',
                text: 'Blog Gagal Diupdate! Silahkan coba lagi',
            })
          })

      }

    },

  },

  created() {
    this.go()
    //console.log(this.params)
  }

}
</script>
